module.exports = __webpack_public_path__ + "img/logo_bank_sinarmas.4bec9464.png";